import { CustomConverter, DateTimeConverter, JsonObject, JsonProperty, Optional } from 'json-ts-mapper';

@JsonObject
export class DateEcheance {
  constructor (

    dateEcheance?: Date
  ) {
    this.dateEcheance = dateEcheance;
  }

  @JsonProperty(String)
  @CustomConverter(DateTimeConverter)
  @Optional
  dateEcheance: Date;
}
